var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('iframe',{attrs:{"src":`https://www.youtube.com/embed/${_vm.videoUrl}?autoplay=1&mute=1&loop=1&modestbranding=0&showinfo=1`,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope;","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }